import React from "react";
import './view5.scss'

import MobileImageView5 from '../../../img/landing/mobile-view-5.svg'
import DesktopImageView5 from '../../../img/landing/desktop-view-5.svg'


const View5 =(props) =>{



    return (<>

        <div className="view5">
            <div className={'view-container box-cover-view-5'}>
                <div className={` mb-4`}>
                    <span className='mobile-item title text-medium text-bolder '>ابزارهای کاربردی </span>
                    <span className='desktop-item title text-medium text-bolder'>ابزارهای کاربردی چنگال</span>
                </div>
                <div className={'bottom-border-green'}  />

                <div className={'mb-4'}>
                    <img className={'mobile-item  '} src={ MobileImageView5 } alt={'mobile image'}/>
                    <img className={'desktop-item '} src={ DesktopImageView5} alt={'desktop image'}/>
                </div>
            </div>
        </div>


    </>)
}
export default View5;